export const NatureEnum = [
  { value: 'concrete', icon: 'mdi-wall', label: 'common.natures.concreteLabel' },
  { value: 'liquid', icon: 'mdi-cup-water', label: 'common.natures.liquidLabel' },
  {
    value: 'tissue',
    icon: 'mdi-google-circles-communities',
    label: 'common.natures.tissueLabel'
  },
  {
    value: 'clay',
    icon: 'mdi-crop-landscape',
    label: 'common.natures.clayLabel'
  },
  {
    value: 'sand',
    icon: 'mdi-hexagon-multiple-outline',
    label: 'common.natures.sandLabel'
  },
  {
    value: 'limestone',
    icon: 'mdi-terrain',
    label: 'common.natures.limestoneLabel'
  },
  {
    value: 'coal',
    icon: 'mdi-hexagon-multiple',
    label: 'common.natures.coalLabel'
  },
  {
    value: 'beckGround',
    icon: 'mdi-power-socket-uk',
    label: 'common.natures.beckGroundLabel'
  },
  {
    value: 'bitumen',
    icon: 'mdi-road-variant',
    label: 'common.natures.bitumenLabel'
  },
  {
    value: 'plants',
    icon: 'mdi-flower-outline',
    label: 'common.natures.plantsLabel'
  },
  {
    value: 'humus',
    icon: 'mdi-gamepad-circle',
    label: 'common.natures.humusLabel'
  },
  {
    value: 'vegetableSoil',
    icon: 'mdi-sprout-outline',
    label: 'common.natures.vegetableSoilLabel'
  },
  {
    value: 'sediment',
    icon: 'mdi-clover',
    label: 'common.natures.sedimentLabel'
  },
  {
    value: 'dustyResidues',
    icon: 'mdi-apple-icloud',
    label: 'common.natures.dustyResiduesLabel'
  },
  {
    value: 'gas',
    icon: 'mdi-chart-bubble',
    label: 'common.natures.gasLabel'
  },
  {
    value: 'paperSmear',
    icon: 'mdi-layers-triple-outline',
    label: 'common.natures.paperSmearLabel'
  },
  {
    value: 'scrapMetal',
    icon: 'mdi-vector-square',
    label: 'common.natures.scrapMetalLabel'
  }
];
